export default "__VITE_ASSET__DaDgyeKy__"